var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleVariantOptions && _vm.visibleVariantOptions.length)?_c('ul',{staticClass:"flex items-center -mx-1"},[_vm._l((_vm.visibleVariantOptions),function(item){return _c('li',{key:item.id,staticClass:"px-1"},[_c('NuxtLink',{staticClass:"variant-option rounded-full w-6 h-6 overflow-hidden block border border-gw-grey-400 hover:border-gw-primary",style:(!!item.colorHex
          ? {
              'background-color': item.colorHex,
            }
          : undefined),attrs:{"to":_vm.localePath(
          item.url
            ? {
                name: 'product-detail-slug',
                params: {
                  slug: item.url,
                },
              }
            : {
                name: 'index',
              }
        )}},[(!item.colorHex)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(((item.img) + "?h=100")),expression:"`${item.img}?h=100`"}],staticClass:"w-full h-full object-contain",attrs:{"alt":item.name,"height":"24","width":"24"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("variant item")])])],1)}),_vm._v(" "),(_vm.otherVariantsLength > 0)?_c('li',[_c('p',{staticClass:"text-gw-grey-500 text-base"},[_vm._v("+"+_vm._s(_vm.otherVariantsLength))])]):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }